/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementCreateEventItemRequest } from './EventManagementCreateEventItemRequest';

export type EventManagementEditEventRequest = {
    id: number;
    title?: string;
    titleEn?: string;
    titleCn?: string;
    startDatetime?: string;
    endDatetime?: string;
    isPreEntry?: boolean;
    preEntryEndTime?: string;
    thumbnailNo?: number;
    isUploadThumbnails?: boolean;
    imageId?: number;
    context?: string;
    contextEn?: string;
    contextCn?: string;
    postDate?: string;
    openStatus?: EventManagementEditEventRequest.openStatus;
    releaseSetting?: EventManagementEditEventRequest.releaseSetting;
    eventItems?: Array<EventManagementCreateEventItemRequest>;
};

export namespace EventManagementEditEventRequest {

    export enum openStatus {
        EDIT = 'edit',
        RELEASE = 'release',
        CANCEL = 'cancel',
    }

    export enum releaseSetting {
        NOW = 'now',
        DATE = 'date',
    }


}

